import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    argroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arinv/postgroup");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    bankaccount() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/bankcashacc/allaccount");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    byrsemu(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`arinv/byrsemu/${obj.arinvKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'paymno', 'invoiceno','customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                let url = `/arsttltt${str}`;
                if (obj.viewOption == 'Lines') {
                     url = `/arsttltt/listwithlines${str}`;
                }
                console.log(url);
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get(`arsttltt/detail/${obj.settleKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post("arsttltt", obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.delete(`arsttltt/${obj.settleKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    potongan() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/arpaymtt/potongan");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`arsttltt/posting/${obj.settleKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`arsttltt/unposting/${obj.settleKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.settleKey);
                url = `/arsttltt/print`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.settleKey);
                url = `/arsttltt/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }, 
    exportXls(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor','invoiceno', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }
        let url = `/arsttltt/exportxls${str}`;
        if (obj.viewOption == 'Lines') {
             url = `/arsttltt/exportdtxls${str}`;
        }

        axios({
            url,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            if (obj.viewOption == 'Lines') {
                link.setAttribute('download', 'arsttltt_line.xlsx');
            } else {
                link.setAttribute('download', 'arsttltt.xlsx');
            }                
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });

    },
};